import store from '@/state/store'
import { userHasPermission } from '@/helpers/userPermissions'


export default [
    // Páginas do usuário login, logout, register, esqueci-senha
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['autheasy/loggedIn']) {
                    const raw = localStorage.getItem('user')
                    let user = null
                    try {
                        user = raw ? JSON.parse(raw) : null
                    } catch (e) {
                        user = null
                    }
                    const names = (user && Array.isArray(user.roles)) ? user.roles.map((r) => r.name) : []
                    const canAccessDashboard = names.includes('super') || userHasPermission(user, 'dashboard.view')
                    if (canAccessDashboard) {
                        next({ name: 'home' })
                    } else if (names.includes('customer')) {
                        next({ name: 'customer-calendar' })
                    } else if (names.includes('professional')) {
                        next({ name: 'professional-calendar' })
                    } else {
                        next({ name: 'logout' })
                    }
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/esqueci-senha',
        name: 'esqueci-senha',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                if (store.getters['autheasy/loggedIn']) {
                    const raw = localStorage.getItem('user')
                    let user = null
                    try {
                        user = raw ? JSON.parse(raw) : null
                    } catch (e) {
                        user = null
                    }
                    const names = (user && Array.isArray(user.roles)) ? user.roles.map((r) => r.name) : []
                    const canAccessDashboard = names.includes('super') || userHasPermission(user, 'dashboard.view')
                    if (canAccessDashboard) {
                        next({ name: 'home' })
                    } else if (names.includes('customer')) {
                        next({ name: 'customer-calendar' })
                    } else if (names.includes('professional')) {
                        next({ name: 'professional-calendar' })
                    } else {
                        next({ name: 'logout' })
                    }
                } else {
                    next()
                }
            },
        },
    },
    {
        path: '/configuracoes',
        name: 'settings',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'parceiro', 'admin', 'financial', 'user', 'professional', 'customer'],
        },
        component: () => import('../views/pages/account/settings'),
    },
    {
        path: '/cadastrar/usuario',
        name: 'register',
        meta: {
            authRequired: true,
            // Inclui parceiro/auditoria alinhado ao menu (super segue isento no authGuard)
            roles: ['super', 'partner', 'parceiro', 'admin', 'user', 'auditoria'],
        },
        component: () => import('../views/pages/account/register'),
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    if (process.env.VUE_APP_DEFAULT_AUTH === "easyindustria-api") {
                        store.dispatch('autheasy/loGout')
                    } else {
                        store.dispatch('authfack/logout')
                    }
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.meta && route.meta.authRequired
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },

    // Página inicial Dashboard
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/dashboard',
        name: 'home',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'parceiro', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/dashboard/index')
    },
    {
        path: '/ia/chat',
        name: 'ai-chat',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user', 'professional'],
        },
        component: () => import('../views/pages/dashboard/ChatEasySaude.vue')
    },

    // Página Agenda do Profissional
    {
        path: '/profissional/agenda',
        name: 'professional-calendar',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'user', 'professional'],
        },
        component: () => import('../views/pages/profissionais/index_logged'),
    },
    {
        path: '/profissional/faturamento-repasse',
        name: 'professional-billing',
        meta: {
            authRequired: true,
            roles: ['professional'],
            pageTitle: 'Meus repasses'
        },
        component: () => import('../views/pages/profissionais/professional_contas_pagar'),
    },

    // Demais páginas do sistema
    {
        path: '/cadastros/abordagem',
        name: 'abordagem',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/abordagens/index')
    },
    {
        path: '/financial/agenciaBanc',
        name: 'agencia',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/financial/agenciaBanc/index')
    },
    {
        path: '/atendimentos',
        name: 'Atendimentos',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/atendimentos/index')
    },
    {
        path: '/solicitacoes-reagendamento',
        name: 'SchedulingRequests',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/scheduling-requests/index')
    },
    {
        path: '/processos/autorizar-atendimentos',
        name: 'AuthorizeAttendances',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/processos/authorize-attendances')
    },
    {
        path: '/processos/sessoes-mensais',
        name: 'SessoesMensais',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/atendimentos/sessoes-mensais.vue')
    },
    {
        path: '/processos/gerenciador-senhas',
        name: 'processes.tickets.manager',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('@/views/pages/processos/tickets/TicketManager.vue')
    },
    {
        path: '/financeiro/contas-a-pagar',
        name: 'accounts-payable',
        meta: {
            authRequired: true,
            // super/admin/financeiro + parceiro (fallback); Gate + permissões na API vigoram para o uso real
            roles: ['super', 'partner', 'parceiro', 'admin', 'financial'],
        },
        component: () => import('../views/pages/financial/accounts-payable/index.vue')
    },
    {
        path: '/financeiro/contas-a-receber',
        name: 'accounts-receivable',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'parceiro', 'admin', 'financial'],
        },
        component: () => import('../views/pages/financial/accounts-receivable/index.vue')
    },
    {
        path: '/financeiro/faturamento',
        name: 'billing',
        redirect: '/financeiro/faturamento-evolucoes',
    },
    {
        path: '/financeiro/faturamento-evolucoes',
        name: 'faturamento-evolucoes',
        meta: { authRequired: true, roles: ['super', 'partner', 'admin', 'financial'] },
        component: () => import('../views/pages/financial/billing/EvolutionBillingPage.vue')
    },
    {
        path: '/financeiro/nfse',
        name: 'nfse',
        meta: { authRequired: true, roles: ['super', 'partner', 'admin', 'financial'] },
        component: () => import('../views/pages/financial/nfse/NfseEmissionPage.vue')
    },
    {
        path: '/atendimentos/validacao-parecer',
        name: 'validation-recurrence',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'auditoria', 'user'],
        },
        component: () => import('../views/pages/atendimentos/validation-recurrence')
    },
    {
        path: '/cadastros/calendario',
        name: 'calendar',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/calendario/index')
    },
    {
        path: '/medical-records',
        name: 'medical-records',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'parceiro', 'admin'],
        },
        component: () => import('../views/pages/medical-records/index')
    },
    {
        path: '/financeiro/centro-custo',
        name: 'parametros-centrocusto',
        alias: '/parametros/centrocusto',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/parametros/centrocusto/index')
    },
    {
        path: '/parametros/centroresultado',
        name: 'parametros-centroresultado',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/parametros/centroresultado/index')
    },
    {
        path: '/parametros/cidades',
        name: 'parametros-cidades',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/parametros/cidades/index')
    },
    {
        path: '/parametros/nfse-clinicas',
        name: 'parametros-nfse-clinicas',
        meta: { authRequired: true },
        component: () => import('../views/pages/parametros/nfse-clinicas/index')
    },
    {
        path: '/cadastros/convenio',
        name: 'convenio',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/plano/index')
    },
    {
        path: '/cadastros/empresas',
        name: 'Empresas',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/empresa/index')
    },
    {
        path: '/relatorios/ficha',
        alias: '/relatorios/ficha.vue',
        name: 'Ficha',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/ficha')
    },
    {
        path: '/relatorios/atendimentos/RepasseProfissionais',
        name: 'RepasseProfissionais',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/atendimentos/RepasseProfissionais')
    },
    {
        path: '/relatorios/atendimentos/emissao-nfse',
        name: 'InvoiceIssuanceReport',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin'],
        },
        component: () => import('../views/pages/relatorios/atendimentos/InvoiceIssuanceReport')
    },
    {
        path: '/relatorios/atendimentos/emissao-nfse-tabela',
        name: 'InvoiceIssuanceTable',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/atendimentos/InvoiceIssuanceTable')
    },
    // removido: relatório contas a pagar por vencimento
    {
        path: '/relatorios/contas-a-pagar',
        name: 'AccountsPayablePaid',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'parceiro', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/accounts-payable')
    },
    {
        path: '/relatorios/contas-a-receber',
        name: 'AccountsReceivableReceived',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'parceiro', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/accounts-receivable')
    },
    {
        path: '/relatorios/fluxo-caixa',
        name: 'cash-flow-report',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/fluxo-caixa')
    },
    {
        path: '/relatorios/resumo-repasse-profissional',
        name: 'ResumoRepasseProfissional',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/relatorios/ResumoRepasseProfissional')
    },
    {
        path: '/parametros/historicopadrao',
        name: 'parametros-historicopadrao',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'user'],
        },
        component: () => import('../views/pages/parametros/historicopadrao/index')
    },
    {
        path: '/cadastros/pacientes',
        name: 'Pacients',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'user'],
        },
        component: () => import('../views/pages/pacientes/index')
    },
    {
        path: '/cadastros/plano-contas',
        name: 'plan-accounts',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial'],
        },
        component: () => import('../views/pages/plano_contas/index')
    },
    {
        path: '/cadastros/profissionais',
        name: 'Professionals',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/profissionais/index')
    },
    {
        path: '/cadastros/responsibles',
        name: 'Responsibles',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/responsible/index')
    },
    {
        path: '/selecionar-empresa',
        name: 'SelectCompany',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/account/select-company'),
    },
    {
        path: '/parametros/tipospagamento',
        name: 'parametros-tipospagamento',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/parametros/tipospagamento/index')
    },
    {
        path: '/cadastros/tratamento',
        name: 'tratamento',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/tratamento/index')
    },
    {
        path: '/parametros/unidademed',
        name: 'parametros-unidademed',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'user'],
        },
        component: () => import('../views/pages/parametros/unidademed/index')

    },
    {
        path: '/listar/usuarios',
        name: 'userGetAll',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'financial', 'user'],
        },
        component: () => import('../views/pages/account/getall')
    },
    {
        path: '/usuarios/permissoes',
        name: 'permissions',
        meta: {
            authRequired: true,
            roles: ['super', 'admin'],
        },
        component: () => import('../views/pages/users/permissions')
    },
    {
        path: '/usuarios/auditoria',
        name: 'audit-log',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin'],
        },
        component: () => import('../views/pages/users/audit')
    },
    {
        path: '/usuarios/empresas',
        name: 'user-company-relations',
        meta: {
            authRequired: true,
            roles: ['super'],
        },
        component: () => import('../views/pages/users/user-company-relations')
    },
    {
        path: '/usuarios/ativar-dispositivo',
        name: 'activate-device',
        meta: {
            authRequired: true,
            roles: ['super', 'partner', 'admin', 'user'],
        },
        component: () => import('../views/pages/users/activate-device')
    },
    {
        path: '/cliente/agenda',
        name: 'customer-calendar',
        meta: { authRequired: true,
            roles: ['super', 'partner', 'admin', 'customer'],
            pageTitle: 'Agenda de Pacientes'
        },
        component: () => import('../views/pages/responsible/index_logged')
    },
    {
        path: '/profissional/atendimentos',
        name: 'atendimento.view.professional',
        meta: { authRequired: true,
            // roles: ['super', 'partner', 'admin', 'user', 'professional'],
            pageTitle: 'Atendimentos Profissional'
        },
        component: () => import('../views/pages/profissionais/professional_atendimentos'),
    },
    {
        path: '/tv-chamar-pacientes',
        name: 'tv-chamar-pacientes',
        meta: {
            authRequired: true,
            roles: ['super', 'admin', 'financial'],
        },
        component: () => import('../views/pages/tv/call_patient')
    },
]
